module.exports = __webpack_public_path__ + "static/media/303KnobLabel--accent.2f00019d.svg";